export enum CoachingRequestStatus {
    PENDING = 'PENDING',
    MANAGER_DECLINED = 'MANAGER_DECLINED',
    MANAGER_APPROVED = 'MANAGER_APPROVED',
    COACH_DECLINED = 'COACH_DECLINED',
    COACH_APPROVED = 'COACH_APPROVED',
    CLOSED = 'CLOSED'
}